import { Injectable } from '@angular/core';
import * as Cookies from 'js-cookie';
import store from 'store';
@Injectable({
  providedIn: 'root'
})
export class StoreService {
  id = Math.random();
  constructor() { }
  /**
   * 根据key获取值， 1为cookie，2为localstorage
   */
  get (key: string, type = 1) {
    return type === 1 ? this.cookieGet(key)
                      : this.storageGet(key);
  }

  /**
   * 设置key和value的值，1为cookie，2为localstorage
   */
  set (key: string, value: any, type = 1, options = null) {
    return type === 1 ? this.cookieSet(key, value, options)
                      : this.storageSet(key, value);
  }
  /**
   * 根据key返回json对象，理论上只对cookie有用，因为storage可以存储对象
   */
  getJSON (key: string, type = 1) {
    return type === 1 ? this.cookieGetJSON(key)
                      : this.storageGet(key);
  }

  /**
   * 根据key删除某个键值对
   */
  remove (key: string, type = 1) {
    return type === 1 ? this.cookieRemove(key)
                      : this.storageRemove(key);
  }
  /**
   * 清除全部的键值对
   */
  clear (type = 1) {
    return type === 1 ? this.cookieClear()
                      : store.clearAll();
  }

  /** cookie相关 */
  cookieGet (key: string) {
    return Cookies.get(key);
  }

  cookieGetJSON (key: string) {
    return Cookies.getJSON(key);
  }

  cookieSet (key: string, value: any, options: object) {
    Cookies.set(key, value, options);
  }

  cookieRemove (key) {
    Cookies.remove(key);
  }

  cookieClear () {
    const all = Cookies.get();
    const keys = all ? Object.keys(all) : [];
    keys.forEach(key => Cookies.remove(key));
  }

  /** localstorage相关 */
  storageGet (key: string) {
    return store.get(key);
  }
  storageSet (key: string, value: any) {
    store.set(key, value);
  }
  storageRemove (key: string) {
    store.remove(key);
  }
}
